import { render, staticRenderFns } from "./ShippingIntegrationAdd.vue?vue&type=template&id=4ce701fc&scoped=true"
import script from "./ShippingIntegrationAdd.vue?vue&type=script&lang=js"
export * from "./ShippingIntegrationAdd.vue?vue&type=script&lang=js"
import style0 from "./ShippingIntegrationAdd.vue?vue&type=style&index=0&id=4ce701fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce701fc",
  null
  
)

export default component.exports